export default {
  'login.title': 'Connexion Administrateur',
  'login.subtitle': 'Connectez-vous avec votre compte administrateur, attribue par le super administrateur',
  'login.email': 'Nom d\'utilisateur / E-mail',
  'login.emailPlaceholder': 'Entrez votre nom d\'utilisateur ou e-mail',
  'login.password': 'Mot de passe',
  'login.passwordPlaceholder': 'Entrez votre mot de passe',
  'login.submit': 'Connexion',
  'login.loading': 'Connexion en cours...',
  'login.failed': 'Echec de connexion',
  'login.networkError': 'Erreur reseau',
  'login.unknownError': 'Erreur inconnue',
  'login.emptyFields': 'Veuillez entrer le nom d\'utilisateur et le mot de passe',
  'login.showPassword': 'Afficher le mot de passe',
  'login.hidePassword': 'Masquer le mot de passe',
  'login.noSelfRegister': 'L\'inscription libre n\'est pas disponible. Contactez votre super administrateur pour creer un compte.',
  'login.footerText': 'Plateforme de Gestion Multi-locataires',
  'login.brandTitle1': 'Console',
  'login.brandTitle2': 'Multi-locataires',
  'login.brandSlogan': 'Gestion unifiee des locataires, utilisateurs, ressources et politiques de facturation pour des operations plus efficaces et securisees.',
  'login.feature1Title': 'Controle d\'acces',
  'login.feature1Desc': 'Controle d\'acces et journaux d\'audit de niveau entreprise',
  'login.feature2Title': 'Isolation des donnees',
  'login.feature2Desc': 'Isolation des donnees multi-locataires et gestion des quotas',
  'login.feature3Title': 'Surveillance',
  'login.feature3Desc': 'Tableaux de bord de surveillance en temps reel et rapports analytiques',
  'sidebar.home': 'Tableau de bord',
  'sidebar.users': 'Utilisateurs et Permissions',
  'sidebar.resources': 'Fonctionnalites et Ressources',
  'sidebar.tenants': 'Gestion des Locataires',
  'sidebar.audit': 'Journal d\'audit',
  'sidebar.reports': 'Rapports',
  'sidebar.settings': 'Parametres',
  'sidebar.admin': 'Administrateur',
  'header.search': 'Rechercher locataires, utilisateurs, ressources...',
  'header.notifications': 'Notifications',
  'header.viewAll': 'Voir toutes les notifications',
  'header.profile': 'Profil',
  'header.settings': 'Parametres',
  'header.logout': 'Deconnexion',
  'header.notif.newTenant': 'Nouveau locataire inscrit',
  'header.notif.newTenantMsg': 'Tech Innovation SARL s\'est inscrit',
  'header.notif.apiWarning': 'Alerte utilisation API',
  'header.notif.apiWarningMsg': 'Le locataire T002 approche la limite du quota',
  'header.notif.systemUpdate': 'Mise a jour systeme',
  'header.notif.systemUpdateMsg': 'Maintenance systeme ce soir',
  'header.notif.5minAgo': 'Il y a 5 min',
  'header.notif.1hourAgo': 'Il y a 1 heure',
  'header.notif.3hoursAgo': 'Il y a 3 heures',
  'home.title': 'Vue d\'ensemble',
  'home.subtitle': 'Bienvenue, voici votre plateforme de gestion multi-locataires',
  'home.totalTenants': 'Total Locataires',
  'home.totalUsers': 'Total Utilisateurs',
  'home.apiCalls': 'Appels API',
  'home.totalRevenue': 'Revenu Total',
  'home.totalSkills': 'Total Competences',
  'home.chatSessions': 'Sessions de Chat',
  'home.totalMessages': 'Total Messages',
  'home.systemHealth': 'Sante Systeme',
  'home.active': 'actifs',
  'home.activeShort': 'actifs',
  'home.thisMonth': 'Ce mois',
  'home.published': 'publies',
  'home.cumulative': 'Cumule',
  'home.running': 'Fonctionnement normal',
  'home.vsLastMonth': 'vs mois dernier',
  'home.apiTrend': 'Tendance API',
  'home.revenueTrend': 'Tendance Revenus',
  'home.quickAccess': 'Acces Rapide',
  'home.recentActivity': 'Activite Recente',
  'home.viewAll': 'Tout voir',
  'home.tenantDistribution': 'Distribution Locataires',
  'home.success': 'Succes',
  'home.failed': 'Echoue',
  'tenants.title': 'Gestion des Locataires',
  'tenants.subtitle': 'Gerer la configuration, les quotas et les politiques de facturation',
  'tenants.export': 'Exporter la liste',
  'tenants.create': 'Nouveau Locataire',
  'tenants.total': 'Total',
  'tenants.unit': 'locataires',
  'tenants.clickTip': 'Cliquez sur une ligne pour voir les details',
  'tenants.showing': 'Affichage',
  'tenants.to': '-',
  'tenants.of': 'sur',
  'tenants.records': 'enregistrements',
  'tenants.createTitle': 'Nouveau Locataire',
  'tenants.createSuccess': 'Locataire cree avec succes !',
  'tenants.createFailed': 'Echec de creation',
  'tenants.tenantName': 'Nom du Locataire',
  'tenants.subdomain': 'Sous-domaine',
  'tenants.contactName': 'Nom du Contact',
  'tenants.contactEmail': 'E-mail du Contact',
  'tenants.planType': 'Type de Plan',
  'tenants.deployRegion': 'Region de Deploiement',
  'tenants.cancel': 'Annuler',
  'tenants.createBtn': 'Creer Locataire',
  'tenants.namePlaceholder': 'ex: Tech Innovation SARL',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': 'Jean Dupont',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'Basique',
  'tenants.plan.professional': 'Professionnel',
  'tenants.plan.enterprise': 'Entreprise',
  'tenants.region.east': 'Chine Est',
  'tenants.region.north': 'Chine Nord',
  'tenants.region.south': 'Chine Sud',
  'tenants.region.west': 'Chine Ouest',
  'tenantStats.total': 'Total Locataires',
  'tenantStats.active': 'Locataires Actifs',
  'tenantStats.totalUsers': 'Total Utilisateurs',
  'tenantStats.monthlyRevenue': 'Revenu Mensuel',
  'tenantFilters.search': 'Rechercher nom, domaine ou contact...',
  'tenantFilters.allPlans': 'Tous les Plans',
  'tenantFilters.allStatus': 'Tous les Statuts',
  'tenantFilters.active': 'Actif',
  'tenantFilters.suspended': 'Suspendu',
  'tenantFilters.trial': 'Essai',
  'tenantTable.info': 'Info Locataire',
  'tenantTable.plan': 'Plan',
  'tenantTable.status': 'Statut',
  'tenantTable.users': 'Utilisateurs',
  'tenantTable.apiCalls': 'Appels API',
  'tenantTable.storage': 'Stockage',
  'tenantTable.region': 'Region',
  'tenantTable.lastActive': 'Derniere Activite',
  'tenantTable.actions': 'Actions',
  'tenantTable.viewDetail': 'Voir details',
  'tenantTable.edit': 'Modifier',
  'tenantTable.more': 'Plus',
  'tenantTable.noMatch': 'Aucun locataire correspondant',
  'tenantDetail.overview': 'Apercu',
  'tenantDetail.quotaMgmt': 'Gestion Quotas',
  'tenantDetail.dataIsolation': 'Isolation Donnees',
  'tenantDetail.billing': 'Facturation',
  'tenantDetail.createdAt': 'Cree le',
  'tenantDetail.resourceUsage': 'Utilisation Ressources',
  'tenantDetail.apiCallUsage': 'Appels API',
  'tenantDetail.storageUsage': 'Stockage',
  'tenantDetail.userCount': 'Nombre Utilisateurs',
  'tenantDetail.contactInfo': 'Informations Contact',
  'tenantDetail.contact': 'Contact',
  'tenantDetail.email': 'E-mail',
  'tenantDetail.deployRegion': 'Region Deploiement',
  'tenantDetail.lastActive': 'Derniere Activite',
  'tenantDetail.enabledFeatures': 'Fonctionnalites Activees',
  'tenantDetail.tags': 'Tags Locataire',
  'tenantDetail.quickActions': 'Actions Rapides',
  'tenantDetail.suspend': 'Suspendre Locataire',
  'tenantDetail.resume': 'Reactiver Locataire',
  'tenantDetail.sendNotice': 'Envoyer Notification',
  'tenantDetail.simulateLogin': 'Simuler Connexion',
  'tenantDetail.exportData': 'Exporter Donnees',
  'tenantDetail.quotaSaved': 'Quota sauvegarde',
  'tenantDetail.quotaSettings': 'Parametres Quota',
  'tenantDetail.quotaDesc': 'Ajuster les limites de ressources pour ce locataire',
  'tenantDetail.maxUsers': 'Max Utilisateurs',
  'tenantDetail.apiCallsMonth': 'Appels API / Mois',
  'tenantDetail.storageSpace': 'Stockage',
  'tenantDetail.currentUsage': 'Utilisation actuelle',
  'tenantDetail.saveQuota': 'Sauvegarder Quotas',
  'tenantDetail.isolationSaved': 'Politique d\'isolation sauvegardee',
  'tenantDetail.isolationPolicy': 'Politique d\'Isolation',
  'tenantDetail.isolationDesc': 'Choisir la methode de stockage et d\'isolation pour ce locataire',
  'tenantDetail.dedicated': 'Isolation Dediee',
  'tenantDetail.dedicatedDesc': 'Instance de base de donnees dediee, isolation complete, securite maximale',
  'tenantDetail.shared': 'Isolation Partagee',
  'tenantDetail.sharedDesc': 'Instance partagee avec securite au niveau des lignes, cout inferieur',
  'tenantDetail.recommended': 'Recommande',
  'tenantDetail.permissionConfig': 'Configuration Permissions',
  'tenantDetail.crossTenantAccess': 'Acces Donnees Inter-locataires',
  'tenantDetail.crossTenantDesc': 'Autoriser l\'acces aux donnees publiques d\'autres locataires',
  'tenantDetail.apiRateLimit': 'Limitation Debit API',
  'tenantDetail.apiRateLimitDesc': 'Appliquer des limites de debit aux requetes API',
  'tenantDetail.dataExport': 'Permission Export Donnees',
  'tenantDetail.dataExportDesc': 'Autoriser ce locataire a exporter ses donnees',
  'tenantDetail.auditAccess': 'Acces Journal Audit',
  'tenantDetail.auditAccessDesc': 'Autoriser l\'acces a ses propres journaux d\'audit',
  'tenantDetail.saveIsolation': 'Sauvegarder Politique Isolation',
  'tenantDetail.currentPlan': 'Frais du Plan Actuel',
  'tenantDetail.perMonth': '/ mois',
  'tenantDetail.nextBilling': 'Prochaine facture',
  'tenantDetail.billDetail': 'Details Facture',
  'tenantDetail.baseFee': 'Frais de Base',
  'tenantDetail.apiCallFee': 'Frais Appels API',
  'tenantDetail.storageFee': 'Frais Stockage',
  'tenantDetail.supportFee': 'Frais Support',
  'tenantDetail.total': 'Total',
  'tenantDetail.historyBills': 'Historique Factures',
  'tenantDetail.paid': 'Paye',
  'tenantDetail.download': 'Telecharger',
  'tenantDetail.feature.aiModels': 'Modeles IA',
  'tenantDetail.feature.apiAccess': 'Acces API',
  'tenantDetail.feature.advancedAnalytics': 'Analyses Avancees',
  'tenantDetail.feature.basicAnalytics': 'Analyses Basiques',
  'tenantDetail.feature.customDomain': 'Domaine Personnalise',
  'tenantDetail.feature.sso': 'SSO',
  'tenantDetail.feature.whiteLabel': 'Marque Blanche',
  'users.title': 'Utilisateurs et Permissions',
  'users.subtitle': 'Gerer les comptes utilisateurs et les permissions de tous les locataires',
  'users.addUser': 'Ajouter Utilisateur',
  'users.totalUsers': 'Total Utilisateurs',
  'users.activeUsers': 'Utilisateurs Actifs',
  'users.admins': 'Administrateurs',
  'users.developers': 'Developpeurs',
  'users.loading': 'Chargement...',
  'userFilters.search': 'Rechercher nom, e-mail ou locataire...',
  'userFilters.allRoles': 'Tous les Roles',
  'userFilters.admin': 'Administrateur',
  'userFilters.user': 'Utilisateur',
  'userFilters.developer': 'Developpeur',
  'userFilters.allStatus': 'Tous les Statuts',
  'userFilters.active': 'Actif',
  'userFilters.inactive': 'Inactif',
  'userFilters.moreFilters': 'Plus de Filtres',
  'userTable.user': 'Utilisateur',
  'userTable.tenant': 'Locataire',
  'userTable.role': 'Role',
  'userTable.status': 'Statut',
  'userTable.lastLogin': 'Derniere Connexion',
  'userTable.actions': 'Actions',
  'userTable.role.admin': 'Administrateur',
  'userTable.role.user': 'Utilisateur',
  'userTable.role.developer': 'Developpeur',
  'userTable.status.active': 'Actif',
  'userTable.status.inactive': 'Inactif',
  'resources.title': 'Configuration Services',
  'resources.subtitle': 'Gerer les modeles IA, cles API et integrations tierces',
  'resources.refresh': 'Actualiser',
  'resources.addConfig': 'Ajouter Config',
  'resources.totalConfigs': 'Total Configs',
  'resources.active': 'Actif',
  'resources.categories': 'Categories',
  'resources.secrets': 'Secrets',
  'resources.addTitle': 'Nouvelle Configuration',
  'resources.category': 'Categorie',
  'resources.configKey': 'Cle de Config',
  'resources.displayName': 'Nom d\'Affichage',
  'resources.value': 'Valeur',
  'resources.description': 'Description',
  'resources.secretValue': 'Valeur secrete',
  'resources.type': 'Type :',
  'resources.save': 'Sauvegarder',
  'resources.cancel': 'Annuler',
  'resources.create': 'Creer',
  'resources.configs': 'configs',
  'resources.items': 'elements',
  'resources.notConfigured': 'Non Configure',
  'resources.noConfigs': 'Aucune configuration trouvee',
  'resources.running': 'En cours',
  'resources.maintenance': 'En maintenance',
  'resources.endpoint': 'Point d\'acces',
  'resources.usageTenants': 'Locataires utilisant',
  'resources.usageUnit': '',
  'resources.usage': 'Utilisation',
  'resources.configure': 'Configurer',
  'resources.stats': 'Statistiques',
  'resources.modelType': 'Type',
  'resources.version': 'Version',
  'resources.callCount': 'Nombre d\'appels',
  'resources.cost': 'Cout',
  'resources.apiKey': 'Cle API',
  'resources.edit': 'Modifier',
  'resources.usageStats': 'Statistiques d\'utilisation',
  'settings.title': 'Parametres Systeme',
  'settings.subtitle': 'Gerer la configuration globale, les politiques de securite et la localisation',
  'settings.tab.general': 'General',
  'settings.tab.services': 'Services',
  'settings.tab.security': 'Securite',
  'settings.tab.notification': 'Notifications',
  'settings.tab.billing': 'Plans de Facturation',
  'settings.tab.locale': 'Langues',
  'settings.systemInfo': 'Info Systeme',
  'settings.version': 'Version',
  'settings.environment': 'Environnement',
  'settings.production': 'Production',
  'settings.availability': 'Disponibilite',
  'settings.lastBackup': 'Derniere Sauvegarde',
  'settings.todayAt': 'Aujourd\'hui 03:00',
  'general.platformInfo': 'Informations Plateforme',
  'general.platformName': 'Nom Plateforme',
  'general.platformUrl': 'URL Plateforme',
  'general.supportEmail': 'E-mail Support',
  'general.timezone': 'Fuseau Horaire',
  'general.dateFormat': 'Format de Date',
  'general.maxTenants': 'Max Locataires / Plan',
  'general.sessionMaintenance': 'Session et Maintenance',
  'general.sessionTimeout': 'Timeout Session',
  'general.sessionTimeoutDesc': 'Deconnexion auto apres inactivite',
  'general.minutes': 'minutes',
  'general.maintenanceMode': 'Mode Maintenance',
  'general.maintenanceDesc': 'Les utilisateurs verront une page de maintenance',
  'general.maintenanceWarning': 'Le mode maintenance est active. Tous les utilisateurs ne peuvent pas acceder a la plateforme.',
  'general.reset': 'Reinitialiser',
  'general.save': 'Sauvegarder',
  'general.saved': 'Sauvegarde',
  'security.authPolicy': 'Politique d\'Authentification',
  'security.mfa': 'MFA Obligatoire',
  'security.mfaDesc': 'Tous les comptes administrateurs doivent activer le MFA',
  'security.sso': 'SSO',
  'security.ssoProtocol': 'Protocole actuel',
  'security.passwordPolicy': 'Politique de Mot de Passe',
  'security.minLength': 'Longueur Minimale',
  'security.chars': 'caracteres',
  'security.expireDays': 'Expiration du Mot de Passe',
  'security.days': 'jours',
  'security.maxAttempts': 'Tentatives Max de Connexion',
  'security.times': 'fois',
  'security.lockoutDuration': 'Duree de Verrouillage',
  'security.ipWhitelist': 'Liste Blanche IP',
  'security.ipPlaceholder': 'Entrer IP ou CIDR, ex: 192.168.1.0/24',
  'security.add': 'Ajouter',
  'security.ipWhitelistDesc': 'Seules les adresses IP de la liste blanche pourront acceder au panneau d\'administration.',
  'security.auditLog': 'Journal d\'Audit',
  'security.retentionDays': 'Jours de Retention',
  'security.retentionDesc': 'Les journaux plus anciens seront automatiquement supprimes',
  'security.reset': 'Reinitialiser',
  'security.save': 'Sauvegarder',
  'security.saved': 'Sauvegarde',
  'notification.channels': 'Canaux de Notification',
  'notification.email': 'Notifications E-mail',
  'notification.emailDesc': 'Envoyer les alertes et rapports par e-mail',
  'notification.sms': 'Notifications SMS',
  'notification.smsDesc': 'Envoyer les alertes urgentes par SMS',
  'notification.webhook': 'Webhook',
  'notification.webhookDesc': 'Envoyer les evenements a une URL specifiee',
  'notification.webhookUrl': 'URL Webhook',
  'notification.alertEvents': 'Evenements d\'Alerte',
  'notification.tenantCreate': 'Inscription Nouveau Locataire',
  'notification.tenantCreateDesc': 'Notifier lors de l\'inscription d\'un nouveau locataire',
  'notification.quotaExceed': 'Alerte Quota Depasse',
  'notification.quotaExceedDesc': 'Notifier quand l\'utilisation API depasse 90%',
  'notification.loginFail': 'Alerte Echec Connexion',
  'notification.loginFailDesc': 'Notifier quand les echecs de connexion atteignent le seuil',
  'notification.systemError': 'Alerte Erreur Systeme',
  'notification.systemErrorDesc': 'Notifier immediatement en cas d\'erreur critique',
  'notification.scheduledReport': 'Rapports Programmes',
  'notification.dailyReport': 'Rapport Quotidien',
  'notification.dailyReportDesc': 'Envoyer un resume quotidien des donnees operationnelles',
  'notification.sendTime': 'Heure d\'Envoi',
  'notification.recipients': 'Destinataires',
  'notification.emailPlaceholder': 'Entrer l\'adresse e-mail',
  'notification.addBtn': 'Ajouter',
  'notification.reset': 'Reinitialiser',
  'notification.save': 'Sauvegarder',
  'notification.saved': 'Sauvegarde',
  'billing.saved': 'Plan sauvegarde',
  'billing.totalPlans': 'Total Plans',
  'billing.activePlans': 'Plans Actifs',
  'billing.highestPrice': 'Prix le Plus Eleve',
  'billing.editing': 'En cours d\'edition',
  'billing.cancel': 'Annuler',
  'billing.save': 'Sauvegarder',
  'billing.planName': 'Nom du Plan',
  'billing.monthlyFee': 'Frais Mensuel (CNY)',
  'billing.apiCallsMonth': 'Appels API / Mois',
  'billing.storageSpace': 'Stockage (GB)',
  'billing.maxUsers': 'Max Utilisateurs',
  'billing.supportType': 'Type de Support',
  'billing.disabled': 'Desactive',
  'billing.perMonth': '/ mois',
  'billing.edit': 'Modifier',
  'billing.apiLabel': 'Appels API',
  'billing.storageLabel': 'Stockage',
  'billing.usersLabel': 'Utilisateurs',
  'billing.supportLabel': 'Support',
  'locale.defaultLang': 'Parametres Langue par Defaut',
  'locale.platformDefault': 'Langue par Defaut',
  'locale.platformDefaultDesc': 'Langue utilisee pour les nouveaux visiteurs',
  'locale.fallbackLang': 'Langue de Secours',
  'locale.fallbackLangDesc': 'Utilisee quand la traduction est manquante',
  'locale.autoDetect': 'Detection Auto Langue Navigateur',
  'locale.autoDetectDesc': 'Changer automatiquement la langue selon le navigateur',
  'locale.tenantOverride': 'Permettre Personnalisation Langue Locataire',
  'locale.tenantOverrideDesc': 'Les locataires peuvent remplacer la langue par defaut',
  'locale.langManagement': 'Gestion Packs Langue',
  'locale.enabled': 'actives',
  'locale.default': 'Par defaut',
  'locale.translationCoverage': 'Couverture Traduction',
  'locale.cannotDisable': 'La langue par defaut ne peut pas etre desactivee',
  'locale.coverageNote': 'Note sur la Couverture',
  'locale.coverageDesc': 'Les packs avec une couverture inferieure a 80% peuvent afficher certains elements dans la langue de secours.',
  'locale.save': 'Sauvegarder',
  'locale.saved': 'Sauvegarde',
  'serviceConfigs.title': 'Configuration Services',
  'serviceConfigs.subtitle': 'Gerer les modeles IA, cles API tierces et integrations',
  'serviceConfigs.refresh': 'Actualiser',
  'audit.title': 'Journal d\'Audit',
  'audit.subtitle': 'Enregistrements des operations et audit de securite',
  'audit.totalLogs': 'Total Journaux',
  'audit.totalLogsDesc': 'Tous les enregistrements',
  'audit.successOps': 'Operations Reussies',
  'audit.successRate': 'Taux de succes',
  'audit.failedOps': 'Operations Echouees',
  'audit.failedDesc': 'Necessite attention',
  'audit.todayOps': 'Operations Aujourd\'hui',
  'audit.todayDesc': 'Activite du jour',
  'audit.tenant': 'Locataire',
  'audit.allTenants': 'Tous les Locataires',
  'audit.actionType': 'Type d\'Action',
  'audit.allActions': 'Toutes les Actions',
  'audit.status': 'Statut',
  'audit.allStatus': 'Tous les Statuts',
  'audit.success': 'Succes',
  'audit.failed': 'Echoue',
  'audit.timeRange': 'Periode',
  'audit.allTime': 'Tout le Temps',
  'audit.today': 'Aujourd\'hui',
  'audit.last7days': '7 derniers jours',
  'audit.last30days': '30 derniers jours',
  'audit.keyword': 'Recherche par Mot-cle',
  'audit.keywordPlaceholder': 'Rechercher utilisateur, action, ressource...',
  'audit.found': '',
  'audit.records': 'enregistrements trouves',
  'audit.clearFilter': 'Effacer filtres',
  'audit.time': 'Heure',
  'audit.user': 'Utilisateur',
  'audit.action': 'Action',
  'audit.resource': 'Ressource',
  'audit.ipAddress': 'Adresse IP',
  'audit.actions': 'Actions',
  'audit.viewDetail': 'Voir details',
  'audit.showing': 'Affichage',
  'audit.prevPage': 'Precedent',
  'audit.nextPage': 'Suivant',
  'audit.detailTitle': 'Details de l\'Operation',
  'audit.logId': 'ID Journal',
  'audit.operationTime': 'Heure d\'Operation',
  'audit.operationStatus': 'Statut d\'Operation',
  'audit.tenantInfo': 'Info Locataire',
  'audit.tenantId': 'ID Locataire',
  'audit.tenantName': 'Nom Locataire',
  'audit.operationUser': 'Utilisateur',
  'audit.userId': 'ID Utilisateur',
  'audit.userName': 'Nom Utilisateur',
  'audit.operationInfo': 'Info Operation',
  'audit.operationType': 'Type d\'Operation',
  'audit.operationResource': 'Ressource',
  'audit.operationDetail': 'Details',
  'audit.networkInfo': 'Info Reseau',
  'audit.userAgent': 'User Agent',
  'reports.title': 'Rapports et Analyses',
  'reports.subtitle': 'Analyse multi-dimensionnelle et rapports visuels',
  'reports.last7days': '7 derniers jours',
  'reports.last30days': '30 derniers jours',
  'reports.last90days': '90 derniers jours',
  'reports.apiTrend': 'Tendance Appels API',
  'reports.revenueCompare': 'Comparaison Revenus Locataires',
  'reports.resourceUsage': 'Utilisation Ressources',
  'reports.userActivity': 'Activite Utilisateurs',
  'reports.activeUsers': 'Utilisateurs Actifs',
  'reports.newUsers': 'Nouveaux Utilisateurs',
  'reports.tenantSummary': 'Resume Donnees Locataires',
  'reports.tenantName': 'Nom Locataire',
  'reports.apiCalls': 'Appels API',
  'reports.storageUsage': 'Utilisation Stockage',
  'reports.userCount': 'Utilisateurs',
  'reports.revenue': 'Revenus',
  'reports.quotaUsage': 'Utilisation Quota',
  'langSwitcher.title': 'Langue / Language',
};
